import React from "react";
import Employees  from "../modules/EmployeesReport/Employees";
export default function EmployeesReportPage() {
  return <Employees />;
}
